import React from 'react';
import { useI18n } from '../i18n/LanguageContext';

export default function LanguageSwitch() {
  const { lang, setLang } = useI18n();

  return (
    <div className="yk-lang" role="group" aria-label="Language">
      <button
        type="button"
        className={lang === 'ro' ? 'yk-langBtn is-active' : 'yk-langBtn'}
        onClick={() => setLang('ro')}
      >
        RO
      </button>
      <span className="yk-langSep" aria-hidden="true">
        |
      </span>
      <button
        type="button"
        className={lang === 'en' ? 'yk-langBtn is-active' : 'yk-langBtn'}
        onClick={() => setLang('en')}
      >
        EN
      </button>
    </div>
  );
}
